export default "__VITE_ASSET__CBpZjpyJ__"